import { render, staticRenderFns } from "./CatalogueDesktopFilters.vue?vue&type=template&id=26c5cb58"
import script from "./CatalogueDesktopFilters.vue?vue&type=script&lang=js"
export * from "./CatalogueDesktopFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports